import Icon from '@/assets/icons/Icon';
import Card from '../ui/Card';
import Flex from '../ui/Flex';
import { NavLink } from 'react-router-dom';
import ProxyPoolTable from './ProxyPoolTable';

export default function ProxyPools() {
  return (
    <Card className="sm:w-[1200px] w-full">
      <Flex.Col className="gap-5">
        <Flex.Row className="justify-between">
          <div className="text-xl font-semibold">Proxy pools</div>
          <NavLink
            to="/proxy-pool/create"
            className="rounded-lg border border-gray-200 hover:border-gray-300 hover:bg-gray-50"
          >
            <Flex.Row className="h-9 px-3 py-2 gap-1 items-center">
              <Icon.Cross />
              <div className="text-sm">Create proxy pool</div>
            </Flex.Row>
          </NavLink>
        </Flex.Row>
        <ProxyPoolTable />
      </Flex.Col>
    </Card>
  );
}
